import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            // Use FormData to send data as application/x-www-form-urlencoded
            const formData = new URLSearchParams();
            formData.append('username', username);
            formData.append('password', password);

            // Sending form data in the right format
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/auth/token`, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Make sure the headers are set to form-urlencoded
                },
            });

            // Handle response based on the correct key (`access_token`)
            const { access_token } = response.data;

            // Save JWT and redirect
            localStorage.setItem('admin_token', access_token);
            alert('Giriş başarılı!');
            navigate('/admin/index'); // Redirect to AdminIndex
        } catch (error) {
            console.error('Error logging in:', error);
            setError('Invalid username or password');
        }
    };

    return (
        <>
            <Helmet>
                <title>Admin Login</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}>
                <h2>Admin Login</h2>
                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '10px' }}>
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '8px',
                                marginTop: '5px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '8px',
                                marginTop: '5px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                            }}
                        />
                    </div>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <button
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '10px',
                            backgroundColor: '#007BFF',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                        }}
                    >
                        Login
                    </button>
                </form>
            </div>
        </>
    );
};

export default AdminLogin;
